// extracted by mini-css-extract-plugin
export default {"primaryButton":"PrimaryButton_primaryButton__5XFNG","disabled":"PrimaryButton_disabled__BjDj6"};